import { Stack, Group, Text, Button, Box, Paper } from "@mantine/core";
import { IconBadge } from "../common/IconBadge";
import { PanelHeader } from "../common/PanelHeader";
import { attentionItems } from "../../data/mockData";

const shadow = "0 1px 8px rgba(0,0,0,0.05)";

function AttentionRow({ item }) {
  return (
    <Group justify="space-between" wrap="nowrap" gap="sm">
      <Group gap="sm" wrap="nowrap" style={{ minWidth: 0 }}>
        <IconBadge icon={item.icon} color={item.color} size={40} />
        <Stack style={{ minWidth: 0 }} gap={4}>
          <Text fw={400} lh={1.25}>
            {item.title}
          </Text>
          <Text fz="sm" c="gray.6" truncate>
            {item.description}
          </Text>
        </Stack>
      </Group>
      <Button
        size="sm"
        radius="md"
        variant="light"
        color={item.actionColor}
        style={{ flexShrink: 0 }}
        c={"black"}
        w={100}
      >
        {item.action}
      </Button>
    </Group>
  );
}

export function AttentionPanel() {
  const criticalCount = attentionItems.filter((i) => i.critical).length;

  return (
    <Paper
      bg={"#fcfbff"}
      p="xl"
      radius="lg"
      withBorder
      style={{
        borderColor: "#edebeb",
        boxShadow: shadow,
      }}
    >
      <PanelHeader
        leading={
          <Box w={12} h={12} bg="red.6" style={{ borderRadius: "50%" }} />
        }
        title="Nécessite votre attention"
        
        subtitle={`${attentionItems.length} éléments, ${criticalCount} critique`}
      />
      <Stack gap="lg">
        {attentionItems.map((item) => (
          <AttentionRow key={item.id} item={item} />
        ))}
      </Stack>
    </Paper>
  );
}

export default AttentionPanel;
